<template>
    <div id="report-details" class="safe-distance-top-header-two" :class="{ 'safe-distance-bottom-tool': !isShelves }">
        <detail-header :pageTitle="goodsTitle" :shareInfo="shareInfo"></detail-header>
        <!-- 是否下架 -->
        <Shelves v-if="isShelves" />
        <div v-else>
            <!-- 页面滚动之后出现顶部导航  -->
            <anchor-scroll-nav v-if="tabsTitle.length > 1" :tabsTitleList="tabsTitle" anchorFlag=".anchor-box"
                faBoxId="report-details"></anchor-scroll-nav>
            <!-- 1.顶部图片 100%宽 -->
            <div class="top-img">
                <van-swipe class="my-swipe" indicator-color="white" v-if="albumPicsList.length > 0">
                    <van-swipe-item v-for="(item, index) in albumPicsList" :key="index">
                        <img v-if="item != 'null'" v-lazy="$global.imgUrl + item" alt="" />
                        <img v-else src="@/assets/img/mobile-img/zz_default.png" alt="" />
                    </van-swipe-item>
                </van-swipe>
                <img v-else src="@/assets/img/mobile-img/zz_default.png" alt="" />
            </div>
            <!-- 2.主体内容 区域，统一设置边距-->
            <div class="content">
                <div class="content-details anchor-box" name="商品">
                    <!-- 价格 -->
                    <p class="price" v-if="saleType === 1">
                        <span>¥</span>
                        <span class="price-number">{{ price }}</span>
                    </p>
                    <p class="price price-number" v-else>免费</p>
                    <!-- 标题 -->
                    <h3 class="title" v-html="goodsTitle"></h3>
                    <!-- 报告属性 -->
                    <ul class="nature-list">
                        <li v-for="item in goodsNature" :key="item.attributeTemplateId">
                            <div class="nature-item" v-if="item.attributeValue !== ''">
                                <span v-if="item.attributeTemplateId === '1'">{{ item.attributeValue |
                                    screenClassifyOneName(classifyOneList)
                                }}</span>
                                <span v-else-if="item.attributeTemplateId === '2'">{{ item.attributeValue |
                                    screenClassifyTwoName(classifyTwoList) }}</span>
                                <span v-else>{{ item.attributeValue }}</span>
                                <span v-if="item.attributeTemplateId === '5'">页</span>
                                <span v-if="item.attributeTemplateId === '6'">图表</span>
                            </div>
                        </li>
                    </ul>
                    <!-- 出品机构 -->
                    <p class="team" v-if="goodInstitution !== ''">
                        <span>出品机构：</span>
                        <span>{{ goodInstitution }}</span>
                    </p>
                    <!-- 研究团队 -->
                    <p class="team" v-if="goodTeam !== ''">
                        <span>研究团队：</span>
                        <span>{{ goodTeam }}</span>
                    </p>
                </div>
                <StretchBox class="anchor-box" title="简介" name="简介" :contentText="introText" />
                <StretchBox class="anchor-box" title="目录" name="目录" :contentText="catalogueText" />
                <StretchBox class="anchor-box" title="预览" name="预览" :contentText="previewText" />
                <div class="author-box">
                    <div>
                        <img class="author-img"
                            :src="authorInfo.imgUrl ? $global.imgUrl + authorInfo.imgUrl : require('@/assets/mylogin/default-JG.png')" />
                        <span class="author-name">{{ authorInfo.shopsName }}</span>
                    </div>
                    <van-button type="default" class="author-btn"
                        @click="toAuthor(authorInfo.shopsTypeId, authorInfo.companyId)">查看</van-button>
                </div>
                <div class="recommend-box anchor-box" v-if="recommendList.length > 0" name="推荐">
                    <h2 class="recommend-title">相关推荐</h2>
                    <div class="recommend-list">
                        <BgItem class="bg-item" v-for="item in recommendList.slice(0, 4)" :key="item.id"
                            :title="item.goodsName" :cover="item.albumPics" :price="item.goodsPrice"
                            :industryOne="item.goodsAttributeVoList.industryLevelOne.fieldValue"
                            :industryTwo="item.goodsAttributeVoList.industryLevelTwo.fieldValue"
                            @click.native="toRecommendDetail(item.id)" />
                    </div>
                </div>
            </div>
            <!-- 3.底部分享收藏点击报名 -->
            <footer-toolbar title="图书" :shareInfo="shareInfo" @sharePoster="sharePoster">
                <!-- 分享面板右侧按钮 -->
                <template #right>
                    <van-button v-if="purchaseStatus === 1" type="info" :round="true" @click="toDownload">{{ hasFile === 1 ?
                        '下载报告' : '已购买' }}</van-button>
                    <div v-else>
                        <van-button v-if="isSale === 1" disabled type="info" :round="true">已停售</van-button>
                        <van-button v-else type="info" :round="true" @click="toBuy">立即购买</van-button>
                    </div>
                </template>
            </footer-toolbar>
            <!-- 生成海报及海报分享 遮罩 -->
            <van-overlay class="poster-overlay" :lock-scroll="true" :show="showPoster" @click="restorePageScroll"
                @touchmove.prevent @mousewheel.prevent>
                <div class="wrapper">
                    <div class="book-poster"
                        style="width: 100vw;height: 100vh;display: flex;align-items: center;justify-content: center; position: relative;">
                        <img id="poster" v-if="posterUrl" width="315" height="467" style="object-fit: scale-down;" ref="poster" :src="posterUrl" alt=""
                            crossOrigin="anonymous" />
                    </div>
                </div>
                <div class="poster-html" v-show="showPoster" style="opacity: 0; pointer-events: none">
                    <div class="book-poster">
                        <div id="poster-dom">
                            <div class="book-cover">
                                <img :src="
                                    albumPicsList.length > 0
                                        ? $global.imgUrl + albumPicsList[0]
                                        : require('@/assets/img/mobile-img/zz_default.png')
                                " alt="" />
                            </div>
                            <div class="book-info">
                                <h1 class="book-title" v-html="placardTitle"></h1>
                                <h2 class="book-price">
                                    <span class="price">¥{{ price }}</span>
                                </h2>
                            </div>
                            <div class="poster-bottom">
                                <div class="qr-code-area">
                                    <div ref="qrcode" id="qrcode"></div>
                                    <span>长按识别二维码</span>
                                </div>
                                <img src="@/assets/img/mobile-img/zw-logo.png" alt="" class="logo" />
                            </div>
                        </div>
                    </div>
                </div>
            </van-overlay>
            <!-- 推广弹窗 -->
            <ExtendTool :hasExtend="hasExtend" :shareInfo="shareInfo"
                @sharePoster="(showStatus) => sharePoster(showStatus, true)" />
            <!-- 4.sku面板 -->
            <goods-sku v-if="showSku" :showSku="showSku" :sku="sku" :goods="goods" :initial-sku="initialSku"
                :hideStepper="true" buyText="立即购买" @handleBuy="signUp"
                @updateSkuPannelStatus="(status) => showSku = status"></goods-sku>
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import DetailHeader from "@/views/mobileView/detail/components/detailHeader.vue";
import BgItem from "@/views/mobileView/components/listItem/bgItem.vue";
import AnchorScrollNav from "@/views/mobileView/detail/components/anchorScrollNav.vue";
import Shelves from "@/views/mobileView/detail/components/shelves.vue";
import StretchBox from "./components/stretchBox.vue";
import FooterToolbar from "@/views/mobileView/detail/components/bottomTool.vue";
import ExtendTool from "@/views/mobileView/detail/components/extendTool.vue";
import GoodsSku from "@/views/mobileView/detail/components/goodsSku.vue";


export default {
    // name: "ReportDetails",
    components: {
        DetailHeader,
        Shelves,
        StretchBox,
        BgItem,
        ExtendTool,
        FooterToolbar,
        AnchorScrollNav,
        GoodsSku,
    },
    data() {
        return {
            tabsTitle: [
                {
                    anchorName: "商品",
                    active: true,
                    show: true,
                },
                {
                    anchorName: "简介",
                    active: false,
                    show: true,
                },
                {
                    anchorName: "目录",
                    active: false,
                    show: true,
                },
                {
                    anchorName: "预览",
                    active: false,
                    show: true,
                },
                {
                    anchorName: "推荐",
                    active: false,
                    show: true,
                },
            ],
            shareInfo: {},
            isShelves: false,
            classifyOneList: [],
            classifyTwoList: [],
            albumPicsList: [],
            saleType: "",
            price: "",
            goodsTitle: "",
            goodsNature: [],
            goodInstitution: "",
            goodTeam: "",
            introText: "",
            catalogueText: "",
            previewText: "",
            authorInfo: {},
            recommendList: [],
            purchaseStatus: 0, // 0 -> 未购买 1 -> 已购买
            hasFile: 0, // 0 -> 有文件可下载 1 -> 没有文件
            // 分享系列数据
            showPoster: false,
            posterUrl: "",
            qrcode: null,
            // 推广系列数据
            hasExtend: false,
            // sku系列数据
            showSku: false,
            sku: {
                // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
                // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
                tree: [],
                // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
                list: [],
            },
            initialSku: {},
            goods: {
                // 默认商品 sku 缩略图
                picture: "",
            },
            isSale: 0, // 是否停售 0 未停售，1 已停售
        }
    },
    created() {
        // 获取图书详情接口
        this.reportDetails();
        // 获取报告行业类型一级列表
        this.getReportClassifyOneList()
    },
    filters: {
        // 筛选出行业类型对应名字(一级)
        screenClassifyOneName(value, arr) {
            let SelectArr = arr.filter(item => item.id == value)
            return SelectArr[0].name
        },
        // 筛选出行业类型对应名字(二级)
        screenClassifyTwoName(value, arr) {
            if (arr.length === 0) return ""
            let SelectArr = arr.filter(item => item.id == value)
            return SelectArr[0].name
        },
    },
    computed: {
        placardTitle() {
            return this.goodsTitle.length > 15
                ? this.goodsTitle.substring(0, 16) + "..."
                : this.goodsTitle;
        },
    },
    methods: {
        // 获取报告行业类型一级列表
        async getReportClassifyOneList() {
            const resp = await this.$apis.goodsServe.getReportClassifyOneList()
            if (resp.resultCode === "200") this.classifyOneList = resp.content.indOneList.map(item => ({ name: item.name, id: item.id }))
        },
        // 获取报告行业类型二级列表
        async getReportClassifyTwoList(parentId) {
            const resp = await this.$apis.goodsServe.getReportClassifyTwoList({ parentId })
            if (resp.resultCode === "200") this.classifyTwoList = resp.content.indOtherList.map(item => ({ name: item.name, id: item.id }))
        },
        // 获取报告详情
        async reportDetails() {
            const resp = await this.$apis.goodsServe.getReportDetail({
                id: this.$route.query.id,
            });
            if (resp.resultCode === "200") {
                // 保存收藏
                this.$addStorageEvent(
                    "isCollect",
                    resp.data.collectState == 0
                );
                this.albumPicsList = resp.data.goods.albumPics.split(',')
                this.price = resp.data.price
                this.saleType = resp.data.saleType
                this.goodsTitle = resp.data.goods.goodsName
                this.goodsNature = resp.data.attributeReqDTOList.filter(item => item.attributeTemplateId === '1' || item.attributeTemplateId === '2' || item.attributeTemplateId === '5' || item.attributeTemplateId === '6')
                let ClassifyOneId = resp.data.attributeReqDTOList.filter(item => item.attributeTemplateId === '1')[0].attributeValue
                this.getReportClassifyTwoList(ClassifyOneId)
                this.goodInstitution = resp.data.attributeReqDTOList.filter(item => item.attributeTemplateId === '3')[0].attributeValue
                this.goodTeam = resp.data.attributeReqDTOList.filter(item => item.attributeTemplateId === '4')[0].attributeValue
                this.introText = resp.data.attributeReqDTOList.filter(item => item.attributeTemplateId === '7')[0].attributeValue
                this.catalogueText = resp.data.attributeReqDTOList.filter(item => item.attributeTemplateId === '8')[0].attributeValue
                this.previewText = resp.data.attributeReqDTOList.filter(item => item.attributeTemplateId === '9')[0].attributeValue
                this.authorInfo = resp.data.shopsInfoDto
                this.recommendList = resp.data.goodsList
                this.hasExtend = resp.data.goods.isPromotionGoods === 1
                this.hasFile = resp.data.hasFile ? resp.data.hasFile : 0
                this.purchaseStatus = resp.data.purchaseStatus
                this.isSale = resp.data.isSale
                // 滚动nav显示
                this.tabsTitle[2].show = this.catalogueText !== ""
                this.tabsTitle[3].show = this.previewText !== ""
                this.tabsTitle[4].show = this.recommendList.length > 0
                // 给APP分享需要的内容
                this.shareInfo = {
                    title: resp.data.goods.goodsName,
                    cover: this.albumPicsList[0],
                    artSummary: this.introText,
                    // articleId: this.$route.query.id,
                    // articleType: 11,
                    goodsId: this.$route.query.id,
                    goodsTypeId: resp.data.goods.goodsTypeId,
                    price: resp.data.price,
                    saleType: resp.data.saleType,
                };
                // 微信分享内容
                this.$global.toShare(
                    resp.data.goods.goodsName,
                    this.introText,
                    this.albumPicsList[0]
                );
                // 处理购买sku数据格式
                let { sku, goods, initialSku } = this.$global.formatGoodsDataToVantSku(
                    {
                        goods: resp.data.goods,
                        goodsList: resp.data.goodsList,
                        goodsSkuInfosDto: resp.data.goodsSkuInfosDto,
                        shopsInfoDto: resp.data.shopsInfoDto,
                    },
                    this.price,
                    this.price
                );
                this.sku = sku
                this.goods = goods
                this.initialSku = initialSku
            } else {
                this.isShelves = true
            }
        },
        // 跳转商家详情页
        toAuthor(type, id) {
            console.log(type, id);
            // type: 1->机构 2->期刊   
            let out = this.$route.query.out;
            switch (type) {
                case '1':
                    this.$router.push({
                        path: "/appusesjigou",
                        query: {
                            item: 2,
                            id,
                            out,
                        },
                    });
                    break;
                case '2':
                    this.$router.push({
                        path: "/appusesbaike",
                        query: {
                            item: 1,
                            id,
                            out,
                        },
                    });
                    break;
            }
        },
        // 跳转推荐列表详情页
        toRecommendDetail(id) {
            let out = this.$route.query.out;
            this.$router.push({
                path: "/detail/report",
                query: {
                    id,
                    out,
                },
            });
        },
        // 分享弹窗
        sharePoster(showStatus, isExtend = false) {
            this.showPoster = showStatus;
            if (showStatus) {
                this.$nextTick(() => {
                    this.drawPoster(isExtend);
                });
            }
        },
        // 生成分享海报图片 html to canvas
        drawPoster(isExtend) {
            const _this = this;
            _this.createQrCode(isExtend);
            let scale = window.devicePixelRatio;
            console.log(scale,window.innerWidth,window.innerHeight)
            html2canvas(document.querySelector("#poster-dom"), {
                useCORS: true,
                scrollY: 0,
                scrollX: 0,
                // width/height默认为当前元素的宽高
                // width: 315,
                //height: 467,
                x: 0,
                y: 0,
                backgroundColor: "transparent",
                scale: scale ? scale : 1,
                windowWidth: window.innerWidth,
                windowHeight: window.innerHeight,
            }).then(function (canvas) {
                _this.posterUrl = canvas.toDataURL("image/png");
            });
        },
        // 关闭海报遮罩
        restorePageScroll() {
            this.showPoster = false;
            // 回到页面内，页面顶部导航栏状态恢复
            setTimeout(() => {
                this.$bus.$emit("posterVisibleStatus", this.showPoster);
            }, 500);
        },
        // 生成海报中二维码
        createQrCode(isExtend) {
            const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            // 清空二维码,创建新的二维码
            this.qrcode = null;
            this.$refs["qrcode"].innerHTML = "";
            let text = `${location.href}${isExtend ? "&promoterId=" + userInfo.promoterId : ""
                }`;
            this.qrcode = new QRCode("qrcode", {
                width: 55 * 3,
                height: 55 * 3,
                text,
                correctLevel: QRCode.CorrectLevel.H,
            });
        },
        // 购买后下载报告文件
        async toDownload() {
            if (this.hasFile === 0) return
            Toast({
                message: "正在下载...",
                duration: 2500,
            });
            const resp = await this.$apis.goodsServe.getReportFile({
                goodsId: this.$route.query.id,
            });
            if (resp.resultCode === '200') {
                // var u = navigator.userAgent;
                // var isWeixin = u.toLowerCase().indexOf("micromessenger") !== -1; // 微信内
                let fileStr = `${this.$apis.mainServe.downloads}?fileUrl=${resp.data.filePath}&fileName=${resp.data.nmFlCur}`
                if (this.$route.query.out) {
                    if (this.$global.isAndroid_ios()) {
                        window.android.downloadUrl(fileStr);
                    } else {
                        window.webkit.messageHandlers.downloadUrl.postMessage(fileStr); //ios
                    }
                } else { // H5下载
                    // if (isWeixin) {
                    //     window.location.href = fileStr
                    // } else {
                    //     let oWindow = window.open("", "_blank")
                    //     oWindow.location = fileStr
                    // }
                    window.location.href = fileStr
                }
            } else {
                Toast("文件下载失败！");
            }
        },
        // 打开sku面板
        toBuy() {
            // 判断当前用户是否登录，
            this.$preventFun.Debounce(() => {
                if (sessionStorage.getItem("token")) {
                    this.showSku = true;
                } else {
                    if (this.$route.query.out) {
                        if (this.$global.isAndroid_ios()) {
                            window.android.getToken();
                        } else {
                            window.webkit.messageHandlers.getToken.postMessage("null"); //ios
                        }
                    } else {
                        // 如果未登录，跳转登录页
                        this.$router.push("/logins");
                    }
                }
            })();
        },
        // 提交订单
        signUp(skuData) {
            // 订单参数
            let bookParameterObj = {
                id: skuData.selectedSkuComb.id, // 规格id
                num: skuData.selectedNum, // 调取生成订单所需要的参数
            }
            if (this.$route.query.promoterId) {
                bookParameterObj.promoterId = this.$route.query.promoterId;
            }
            localStorage.setItem("reprotParameter", JSON.stringify([bookParameterObj]));
            // 跳转到确认订单页回显参数
            let information = {
                selectedNum: skuData.selectedNum,
                pictureUrl: skuData.pictureUrl,
                selectedText: skuData.selectedText.replace("已选：", ""),
                id: skuData.selectedSkuComb.id, // 规格id
                skuPrice: skuData.selectedSkuComb.skuPrice,
                goodsTitle: this.goodsTitle,
                shopsName: this.authorInfo.shopsName,
            };
            localStorage.setItem("reprotDetails", JSON.stringify(information));
            // 跟APP联调
            if (this.$route.query.out) {
                information.skuId = skuData.selectedSkuComb.id;
                var appBookParams = {
                    skuData: information,
                    type: 4, // 报告4
                };
                if (this.$global.isAndroid_ios()) {
                    window.android.confirmOrder(JSON.stringify(appBookParams));
                } else {
                    window.webkit.messageHandlers.confirmOrder.postMessage(
                        JSON.stringify(appBookParams)
                    );
                }
            } else {
                // 跳转确认订单页
                this.$router.push({
                    name: "ReportConfirmOrder",
                    params: information,
                });
            }
        },
    }
}
</script>

<style lang='scss' scoped>
#report-details {
    position: relative;
    background: #f5f5f5;
    min-height: 100vh;

    .top-img {
        width: 100%;
        height: 211px;

        .my-swipe .van-swipe-item {
            width: 100%;
            height: 211px;
            color: #fff;
            font-size: 20px;
            line-height: 150px;
            background-color: #f5f5f5;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .content {
        margin: 0 auto;
        width: 351px;

        .content-details {
            margin-top: 12px;
            padding: 12px;
            width: 100%;
            border-radius: 8px;
            background-color: #fff;

            .price {
                margin-bottom: 12px;
                font-size: 12px;
                color: #FF3D3D;
                line-height: 17px;

                .price-number {
                    font-size: 17px;
                    font-weight: 700;
                }
            }

            .title {
                font-size: 17px;
                color: #333333;
                line-height: 24px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            .nature-list {
                margin: 15px 0 15px;

                li {
                    display: inline-block;
                    margin-right: 8px;

                    .nature-item {
                        display: inline-block;
                        padding: 5px 9px;
                        max-width: 100px;
                        background-color: #f5f5f5;
                        border-radius: 18px;
                        font-size: 11px;
                        color: #666666;
                        line-height: 15px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    &:last-child {
                        margin-right: 0;
                    }
                }
            }

            .team {
                margin-top: 8px;
                font-size: 13px;
                color: #999999;
                line-height: 19px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

            }
        }

        .author-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 12px;
            padding: 12px 12px 12px 15px;
            background-color: #fff;
            border-radius: 8px;

            .author-img {
                width: 47px;
                height: 47px;
                border-radius: 50%;
                vertical-align: middle;
            }

            .author-name {
                display: inline-block;
                max-width: 100px;
                margin-left: 10px;
                vertical-align: middle;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .author-btn {
                // padding: 16px;
                // width: 60px;
                height: 32px;
                background-color: #4A79F1;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 32px;
            }
        }

        .recommend-box {
            margin-top: 12px;
            padding: 17px 12px;
            background-color: #FFFFFF;
            border-radius: 8px;

            .recommend-title {
                margin-bottom: 17px;
                font-size: 17px;
                color: #333333;
                line-height: 24px;
            }

            .recommend-list {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;

                .bg-item {
                    width: 158px;
                    margin-bottom: 12px;
                }
            }
        }
    }
}
</style>
<style lang="scss">
@import "~@/assets/styles/poster.scss";
</style>